import { MESSAGE_UNIT_TYPE } from 'common/constants/user';
import { ApiStatus } from 'common/enums';
import {
    DEFAULT_COUNT,
    PAGE_SIZE_DEFAULT,
    PAGE_NUMBER_DEFAULT
} from 'common/config/pagination.config';
import { UserPermissionState } from 'modules/user-management/models/user.model';

const initialUserPermissionState: UserPermissionState = {
    isAdminModalVisible: false,
    permissionList: {
        data: [],
        pageSize: PAGE_SIZE_DEFAULT,
        currentPage: PAGE_NUMBER_DEFAULT,
        totalCount: DEFAULT_COUNT,
        totalPages: DEFAULT_COUNT,
        status: ApiStatus.NONE,
        error: {}
    },
    userList: {
        data: [],
        status: ApiStatus.NONE,
        error: {}
    },
    userRoles: {
        data: [],
        status: ApiStatus.NONE,
        error: {}
    },
    participantsList: [],
    roleList: {
        data: [],
        status: ApiStatus.NONE,
        error: {}
    },
    permissionEditData: undefined,
    permissionDeleteStatus: {},
    roleAssignStatus: {},
    roleEditStatus: {},
    dataForDelete: undefined,
    messageStatus: {
        type: MESSAGE_UNIT_TYPE.Default,
        message: ''
    },
    userPerPage: PAGE_SIZE_DEFAULT,
    fieldErrors: []
};

export default initialUserPermissionState;
